import { render, staticRenderFns } from "./land-news-modal.vue?vue&type=template&id=43157981&scoped=true"
import script from "./land-news-modal.vue?vue&type=script&lang=js"
export * from "./land-news-modal.vue?vue&type=script&lang=js"
import style0 from "./land-news-modal.vue?vue&type=style&index=0&id=43157981&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43157981",
  null
  
)

export default component.exports